// @flow

import type {
  Action,
  FocusAction,
  RemovePaneAction,
  FocusPaneAction,
  InvokeCommandAction,
  UpdatePaneAction,
} from './reducer';

type Dispatch = (Action) => void;

export const setFocus = (dispatch: Dispatch) => (
  payload: $PropertyType<FocusAction, 'payload'>,
) => {
  dispatch({type: 'SET_FOCUS', payload});
};

export const addPane = (dispatch: Dispatch) => () =>
  dispatch({type: 'ADD_PANE'});

export const removePane = (dispatch: Dispatch) => (
  payload: $PropertyType<RemovePaneAction, 'payload'>,
) => {
  dispatch({type: 'REMOVE_PANE', payload});
};

export const focusPane = (dispatch: Dispatch) => (
  payload: $PropertyType<FocusPaneAction, 'payload'>,
) => {
  dispatch({type: 'FOCUS_PANE', payload});
};

export const open = (dispatch: Dispatch) => () => dispatch({type: 'OPEN'});

export const close = (dispatch: Dispatch) => () => dispatch({type: 'CLOSE'});

export const toggleOpen = (dispatch: Dispatch) => () =>
  dispatch({type: 'TOGGLE_OPEN'});

export const toggleMinimize = (dispatch: Dispatch) => () =>
  dispatch({type: 'TOGGLE_MINIMIZE'});

export const invokeCommand = (dispatch: Dispatch) => (
  payload: $PropertyType<InvokeCommandAction, 'payload'>,
) => {
  dispatch({type: 'INVOKE_COMMAND', payload});
};

export const updatePane = (dispatch: Dispatch) => (
  payload: $PropertyType<UpdatePaneAction, 'payload'>,
) => {
  dispatch({type: 'UPDATE_PANE', payload});
};

export const reset = (dispatch: Dispatch) => () => dispatch({type: 'RESET'});

export const lockPanes = (dispatch: Dispatch) => () =>
  dispatch({type: 'LOCK_PANES'});

export const unlockPanes = (dispatch: Dispatch) => () =>
  dispatch({type: 'UNLOCK_PANES'});
